import { render, staticRenderFns } from "./_serviceSimple.vue?vue&type=template&id=50bea71b&"
import script from "./_serviceSimple.vue?vue&type=script&lang=js&"
export * from "./_serviceSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports